import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import PropTypes from 'prop-types';
import cancelarActa from 'assets/images/Imagen_Mensajes.svg';
import './CancelModalMonitoring.scss';

const CancelModalMonitoring = ({
  open,
  openSuccess,
  cancelConfirm,
  handleCerrar,
  title,
  msgSuccess
}) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    form.setFieldValue({ motivo: '' });
    cancelConfirm(values);
    form.resetFields();
  };

  const onClear = () => {
    form.resetFields(['motivo']);
  };

  return (
    <div>
      <Modal
        footer={null}
        width="45em"
        style={{ height: '400px' }}
        open={open}
        onCancel={() => {
          handleCerrar();
          onClear();
        }}
        centered>
        <Form className="form-Cancelacion" layout="vertical" onFinish={onFinish} form={form}>
          <span className="box-gral-inicio">
            <div className="modal-cancelacion-inicio">
              <span>
                {title} <br />
              </span>
            </div>
            <div className="text-area-inicio">
              <span>
                <Form.Item
                  name="motivo"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingresa el motivo de cancelación.'
                    }
                  ]}>
                  <Input.TextArea rows={3} placeholder="Escribe el motivo" />
                </Form.Item>
              </span>
            </div>
            <div className="buttons-cancel-inicio">
              <Button
                className="buttons-cancel-inicio"
                onClick={() => {
                  handleCerrar();
                  onClear();
                }}>
                Cancelar
              </Button>
              <span style={{ width: '3em' }} />
              <Button type="primary" className="buttons-cancel-inicio" htmlType="submit">
                Aceptar
              </Button>
            </div>
          </span>
        </Form>
      </Modal>
      <Modal
        open={openSuccess}
        title=""
        footer={null}
        width="40em"
        onCancel={handleCerrar}
        centered>
        <div>
          <div style={{ marginTop: '50px', display: 'grid', justifyContent: 'center' }}>
            <img alt="example" style={{ width: '170px', marginLeft: '70px' }} src={cancelarActa} />
            <span
              className="modal-elimina-inicio"
              style={{ marginTop: '20px', marginBottom: '35px', fontSize: '23px' }}>
              {msgSuccess}
            </span>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CancelModalMonitoring;

CancelModalMonitoring.propTypes = {
  open: PropTypes.bool,
  openSuccess: PropTypes.bool.isRequired,
  cancelConfirm: PropTypes.func.isRequired,
  handleCerrar: PropTypes.func.isRequired,
  title: PropTypes.string,
  msgSuccess: PropTypes.string
};

CancelModalMonitoring.defaultProps = {
  open: false,
  title: '¿Estás seguro de cancelar el monitoreo?',
  msgSuccess: 'El monitoreo se canceló con éxito.'
};
